import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Dog } from 'lucide-react';

export function EmptyFeed({ onCreateClick }) {
  return (
    <Card className="text-center py-16">
      <CardContent>
        <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-muted flex items-center justify-center">
          <Dog className="w-10 h-10 text-muted-foreground" />
        </div>
        <h3 className="font-heading text-xl mb-2">No posts yet</h3>
        <p className="text-muted-foreground mb-4">Be the first to share something with the community!</p>
        <Button className="btn-primary" onClick={onCreateClick}>
          Create First Post
        </Button>
      </CardContent>
    </Card>
  );
}

export default EmptyFeed;
